.checkbox {
  margin: var(--space-m) 0;
}
